"use client"

import ChatContext from "@/context/chatContext"
import socket from "@/config/socketIO"
import { useContext, useEffect, useState } from "react"
import uuid from "react-native-uuid"

export default function useChat() {
  const { chatData, setChatData } = useContext(ChatContext)

  const [message, setMessage] = useState("")
  const [isConnected, setIsConnected] = useState(socket.connected ?? false)

  const [messages, setMessages] = useState([])

  // Asegúrate de que chatData tiene datos antes de proceder
  const sendMessage = () => {
    if (chatData.length > 0 && message.trim().length > 0) {
      const boom = { message, userId: chatData[0].userId, chatId: chatData[0].chatId }
      socket.emit("msj", boom)
      setMessages((prev) => [
        ...prev,
        {
          message,
          userId: chatData[0].userId ?? "",
          _id: uuid.v4(),
          isRead: false,
          createdAt: new Date(Date.now()),
          chatId: chatData[0].chatId ?? "",
        },
      ])
      setMessage("")
    } else {
      console.error("chatData is empty or message is empty!")
    }
  }

  // Maneja la llegada de nuevos mensajes
  const addToMessages = (chatMessage, callback) => {
    // Check if the message already exists to avoid duplicates
    setMessages((prev) => {
      const messageExists = prev.some(
        (msg) =>
          msg._id === chatMessage._id ||
          (msg.message === chatMessage.message &&
            msg.userId === chatMessage.userId &&
            msg.createdAt === chatMessage.createdAt),
      )

      if (!messageExists) {
        return [...prev, { ...chatMessage, isRead: true }]
      }
      return prev
    })

    callback("ok")
  }

  const handleChatCreation = (newChatId) => {
    setChatData((prev) => ({ ...prev, chatId: newChatId }))
  }

  const joinRoom = () =>
    socket.emit(
      "joinRoom",
      chatData.map((chat) => chat.chatId),
    )

  const enterChat = () => {
    if (chatData.length > 0) {
      socket.emit("enteredChat", { chatId: chatData[0].chatId, userId: chatData[0].userId })
    } else {
      console.error("chatData is empty when entering the chat!")
    }
  }

  // Suscripción a eventos de socket
  useEffect(() => {
    // Solo ejecutamos si chatData tiene datos
    if (chatData.length > 0) {
      socket.on("connect", () => setIsConnected(true))
      socket.on("disconnect", () => setIsConnected(false))
      socket.on("msj", addToMessages)
      socket.on("chatIdCreated", handleChatCreation)

      return () => {
        socket.off("connect", () => setIsConnected(true))
        socket.off("disconnect", () => setIsConnected(false))
        socket.off("msj", addToMessages)
        socket.off("chatIdCreated", handleChatCreation)
      }
    } else {
      console.error("chatData is empty during useEffect setup!")
    }
  }, [chatData])

  return [message, setMessage, isConnected, messages, sendMessage, setMessages, joinRoom, enterChat]
}

